// Migrated from permission.ts to JavaScript

import store from "@/store";

// Helper function to check permissions
function checkPermission(el, binding) {
  const { value, modifiers } = binding;

  if (!value) {
    throw new Error("Permission value is required. Usage: v-permission=\"'users.view'\"");
  }

  const permissions = Array.isArray(value) ? value : [value];

  let hasPermission = false;

  if (modifiers && modifiers.all) {
    // Check if user has all permissions
    hasPermission = store.getters["authpermission/hasAllPermissions"](permissions);
  } else {
    // Check if user has any permission (default)
    hasPermission = store.getters["authpermission/hasAnyPermission"](permissions);
  }

  if (!hasPermission) {
    // Remove element from DOM if no permission
    el.parentNode && el.parentNode.removeChild(el);
  }
}

// Helper function to check roles
function checkRole(el, binding) {
  const { value, modifiers } = binding;

  if (!value) {
    throw new Error("Role value is required. Usage: v-role=\"'owner'\"");
  }

  const roles = Array.isArray(value) ? value : [value];

  let hasRole = false;

  if (modifiers && modifiers.all) {
    // Check if user has all roles
    hasRole = store.getters["authpermission/hasAllRoles"](roles);
  } else {
    // Check if user has any role (default)
    hasRole = store.getters["authpermission/hasAnyRole"](roles);
  }

  if (!hasRole) {
    // Remove element from DOM if no role
    el.parentNode && el.parentNode.removeChild(el);
  }
}

// Helper function to check menu access
function checkMenu(el, binding) {
  const { value } = binding;

  if (!value) {
    throw new Error("Menu item is required. Usage: v-menu=\"'dashboard'\"");
  }

  const isAllowed = store.getters["authpermission/isMenuAllowed"](value);

  if (!isAllowed) {
    // Remove element from DOM if menu not allowed
    el.parentNode && el.parentNode.removeChild(el);
  }
}

// Permission directive
const permission = {
  mounted(el, binding) {
    checkPermission(el, binding);
  },
  updated(el, binding) {
    checkPermission(el, binding);
  },
};

// Role directive
const role = {
  mounted(el, binding) {
    checkRole(el, binding);
  },
  updated(el, binding) {
    checkRole(el, binding);
  },
};

// Menu directive
const menu = {
  mounted(el, binding) {
    checkMenu(el, binding);
  },
  updated(el, binding) {
    checkMenu(el, binding);
  },
};

// Install all directives
const permissionPlugin = {
  install(Vue) {
    Vue.directive("permission", permission);
    Vue.directive("role", role);
    Vue.directive("menu", menu);
  }
};

export default permissionPlugin;